import {
  DropdownInput,
  DropdownInputContent,
  DropdownInputTrigger,
} from '@/ux-common/components/dropdown-input/dropdown-input';
import { DropdownMenuCheckboxItem } from '@/ux-common/components/dropdown-menu/dropdown-menu';
import { withTooltip } from '@/ux-common/components/tooltip/with-tooltip';

import { EVENT_DAYS } from './defrost-schedule.constant';
import {
  type DefrostScheduleEventDayFieldProps,
  useDefrostEventDays,
} from './use-defrost-event-days';

const DropdownInputTriggerWithTooltip = withTooltip(DropdownInputTrigger);

/** Event-days field: a menu of checkbox rows. Its phone twin is DefrostScheduleEventDayMobileMenu. */
export const DefrostScheduleEventDayDropdown = ({
  disabled,
  error,
  onChange,
  values,
}: DefrostScheduleEventDayFieldProps) => {
  const { handleOpenChange, isOpen, selectedDays, toggleDay } = useDefrostEventDays({
    disabled,
    onChange,
    values,
  });

  return (
    <DropdownInput
      data-component="DefrostScheduleEventDayDropdown"
      onOpenChange={handleOpenChange}
      open={isOpen}
      state={error ? 'error' : undefined}
    >
      {/* Wrapped unconditionally — see `settings/components/setting-field-boolean.tsx`
          for why a conditional wrapper remounts the trigger. Here the content is the
          validation message, which clears the moment a first day is picked, so the
          remount would land mid-interaction. */}
      <DropdownInputTriggerWithTooltip
        contentClassName="text-ckds-base-critical"
        disabled={disabled}
        placeholder="Select Day(s)"
        tooltipArrow
        tooltipContent={error ? error : undefined}
      >
        {selectedDays}
      </DropdownInputTriggerWithTooltip>
      <DropdownInputContent className="w-80">
        {EVENT_DAYS.map((day) => (
          <DropdownMenuCheckboxItem
            checked={values?.includes(day.value)}
            key={day.value}
            onCheckedChange={(checked) => toggleDay(checked, day.value)}
          >
            {day.label}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownInputContent>
    </DropdownInput>
  );
};
